/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'

// Store functionality
// import actions from './actions'
import getters from './getters'
import user from './modules/user'
import mutations from './mutations'
// import state from './state'
import type from './modules/type'
// import Repository from '../repositories/Repository'
Vue.use(Vuex)

// Create a new store
const store = new Vuex.Store({
  actions: {
    setToken () {
      // Repository.defaults.headers.common.Authorization = 'Bearer ' + localStorage.getItem('token')
    }
  },
  getters,
  modules: {
    user: user,
    type: type
  },
  mutations,
  state: {
    blur: false,
    sharing: false,
    tab: null,
    window: window.innerWidth,
    sidebar: false,
    welcomeMenu: false,
    loginDialog: false,
    registerDialog: false,
    submitted: false,
    links: [],
    bundleCategories: [],
    prevRoute: localStorage.getItem('lang') === 'ar' ? 'أخبار' : 'News',
    activeNav: 0, // 0 until all section got ready (- 1)
    activeSectionNav: -1,
    sharingLink: '',
    sharedMessage: '',
    sharedTitle: '',
    urlTitle: '',
    supportSectionTabs: null,
    productsInnerTab: null,
    mtnApps: [],
    activeSegment: false,
    prevTab: null,
    rotate: false,
    activeCard: 0,
    editProfile: false,
    profileTab: null,
    flipCard: 0,
    addNewNumber: false,
    selectedNumber: '',
    mainGsm: '',
    forbidden: false,
    passedNum: '',
    passedLineType: '',
    isAdded: 0,
    sliderUpdated: 0,
    offerType: 'special', /* special or general offers */
    // Hotline dialogs
    deactivateHotLine: false,
    activateHotLine: false,
    showSearch: false,
    searchValue: ''
  }
})

export default store
